/* ==========================================================================
   Global theme utilities
   ========================================================================== */
(function () {
  'use strict';

  window.theme = window.theme || {};

  /* Debounce ---------------------------------------------------------- */
  theme.debounce = function (fn, wait) {
    var timeout;
    return function () {
      var args = arguments;
      var context = this;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  };

  /* Fetch config for Shopify AJAX endpoints ---------------------------- */
  theme.fetchConfig = function (type) {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    };
  };

  /* Trap focus within a container (for drawers/modals) ----------------- */
  theme.trapFocus = function (container, autofocusEl) {
    var focusable = container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (focusable.length === 0) return function () {};
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    function handleKeydown(event) {
      if (event.key !== 'Tab') return;
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    container.addEventListener('keydown', handleKeydown);
    (autofocusEl || first).focus();

    return function removeTrap() {
      container.removeEventListener('keydown', handleKeydown);
    };
  };

  var activeFocusTrapRemovers = [];
  theme.lockFocusTrap = function (container, autofocusEl) {
    activeFocusTrapRemovers.push(theme.trapFocus(container, autofocusEl));
  };
  theme.releaseFocusTrap = function () {
    var remover = activeFocusTrapRemovers.pop();
    if (remover) remover();
  };

  /* Body scroll lock ----------------------------------------------------*/
  var scrollLockCount = 0;
  theme.lockScroll = function () {
    scrollLockCount++;
    document.documentElement.style.overflow = 'hidden';
  };
  theme.unlockScroll = function () {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) document.documentElement.style.overflow = '';
  };

  /* Global Escape key closes any open overlay --------------------------*/
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.dispatchEvent(new CustomEvent('theme:escape'));
  });

  /* Scroll-in animations -------------------------------------------------*/
  function initScrollAnimations() {
    var targets = document.querySelectorAll('[data-animate]');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    targets.forEach(function (el) { observer.observe(el); });
  }

  /* Accordions: allow only one open per group (optional, non-forced) ---*/
  document.addEventListener('DOMContentLoaded', function () {
    initScrollAnimations();
  });
  document.addEventListener('shopify:section:load', initScrollAnimations);

  /* Below-the-fold autoplay videos: the `autoplay` attribute alone is
     unreliable for elements not yet painted at load, so nudge playback
     once each one actually scrolls into view. --------------------------*/
  function initDeferredAutoplayVideos() {
    var videos = document.querySelectorAll('video[autoplay]');
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (v) { v.play().catch(function () {}); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.play().catch(function () {});
          }
        });
      },
      { threshold: 0.1 }
    );
    videos.forEach(function (v) { observer.observe(v); });
  }
  document.addEventListener('DOMContentLoaded', initDeferredAutoplayVideos);
  document.addEventListener('shopify:section:load', initDeferredAutoplayVideos);

  /* Wishlist (localStorage-backed placeholder) --------------------------*/
  var WISHLIST_KEY = 'maison24:wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(ids) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids));
    } catch (e) {}
  }

  function refreshWishlistUI() {
    var ids = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      btn.classList.toggle('is-active', ids.indexOf(id) !== -1);
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = ids.length;
      el.hidden = ids.length === 0;
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-wishlist-toggle]');
    if (!toggle) return;
    event.preventDefault();
    var id = toggle.getAttribute('data-product-id');
    var ids = getWishlist();
    var index = ids.indexOf(id);
    if (index === -1) {
      ids.push(id);
    } else {
      ids.splice(index, 1);
    }
    setWishlist(ids);
    refreshWishlistUI();
  });

  document.addEventListener('DOMContentLoaded', refreshWishlistUI);

  /* Broken image fallback -------------------------------------------- */
  document.addEventListener(
    'error',
    function (event) {
      var target = event.target;
      if (target && target.tagName === 'IMG' && !target.dataset.fallbackApplied) {
        target.dataset.fallbackApplied = 'true';
        target.style.opacity = '0';
      }
    },
    true
  );
})();
